import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import cannot from 'ember-can/helpers/cannot';
import type { Task } from 'ember-concurrency';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import { or } from 'ember-truth-helpers';
import ButtonGroup from 'garaje/components/ui/button-group';

interface ReservationDeleteConfirmationSignature {
  Args: {
    deleteReservationTask: Task<void, []>;
    onClose: () => void;
  };
}

export default <template>
  <div data-test-delete-confirmation class="mt-4">
    <div>Do you want to delete this reservation? This cannot be undone.</div>
    <ButtonGroup @reverse={{true}} class="pt-8 flex justify-end">
      <button
        data-test-confirmation-modal-action
        type="button"
        class="btn btn--small btn--brand"
        disabled={{or @deleteReservationTask.isRunning (cannot "delete reservations")}}
        {{on "click" @deleteReservationTask.perform}}
      >
        Delete
        {{#if (cannot "delete reservations")}}
          <EmberTooltip @side="bottom" @text="You don't have permission to delete a reservation." />
        {{/if}}
      </button>
      <button
        data-test-confirmation-modal-cancel
        type="button"
        class="btn btn--small btn--outlineFill"
        disabled={{@deleteReservationTask.isRunning}}
        {{on "click" @onClose}}
      >
        Cancel
      </button>
    </ButtonGroup>
  </div>
</template> satisfies TOC<ReservationDeleteConfirmationSignature>;
